import { HolidayDate } from "./type"
import { SelectOption } from "../../types/SelectOption"
import Select from "react-select"

interface Props {
    holidays: HolidayDate[]
    dealerships: SelectOption[]
    onDealershipChange: (index: number, dealershipIds: number[]) => void
    onDelete: (index: number) => void
}

export function HolidaysTable(props: Props) {
    /**
     * Formate la date au format français (JJ/MM/AAAA)
     */
    const formatDate = (dateString: string): string => {
        const date = new Date(dateString)
        return date.toLocaleDateString('fr-FR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        })
    }

    return (
        <table className="table table-striped table-hover table-sm">
            <thead>
                <tr>
                    <th>Nom</th>
                    <th>Date</th>
                    <th>Site(s)</th>
                    <th className="text-center">Actions</th>
                </tr>
            </thead>
            <tbody>
                {props.holidays.map((holiday, index) => (
                    <tr key={`${holiday.date}-${index}`}>
                        <td>{holiday.name}</td>
                        <td>{formatDate(holiday.date)}</td>
                        <td>
                            <Select
                                multi={true}
                                style={{ minWidth: '40em', maxWidth: '40em' }}
                                value={props.dealerships.filter(d =>
                                    holiday.dealershipIds?.includes(d.value as number)
                                )}
                                onChange={(options: SelectOption[] | null) => {
                                    const dealershipIds = options && options.length > 0
                                        ? options.map(opt => opt.value as number)
                                        : []
                                    props.onDealershipChange(index, dealershipIds)
                                }}
                                options={props.dealerships}
                                placeholder="Tous"
                            />
                        </td>
                        <td className="text-center">
                            <button
                                className="tw-text-sm tw-border-0 tw-bg-red-500 tw-rounded tw-px-2 tw-py-1"
                                onClick={() => props.onDelete(index)}
                                title="Supprimer"
                            >
                                <i className="fa fa-trash tw-text-white"></i>
                            </button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    )
}
